import { render, staticRenderFns } from "./HelpQuestionModal.vue?vue&type=template&id=be53342c"
import script from "./HelpQuestionModal.vue?vue&type=script&lang=js"
export * from "./HelpQuestionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports